import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]

  toggle() {
    const content = this.contentTarget
    const isHidden = content.classList.contains("hidden")

    if (isHidden) {
      content.classList.remove("hidden")
      if (this.hasIconTarget) {
        this.iconTarget.style.transform = "rotate(0deg)"
      }
    } else {
      content.classList.add("hidden")
      if (this.hasIconTarget) {
        this.iconTarget.style.transform = "rotate(-90deg)"
      }
    }
  }
}
